import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import moment from 'moment';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Grid,
  TablePagination,
  TextField,
  Tooltip,
} from '@mui/material';

import {
  Archive,
  Check,
  Link as LinkIcon,
  Visibility,
  History,
  Send as SentIcon,
  Add as CreatedIcon,
  RemoveRedEye as ReviewedIcon,
  Archive as ArchivedIcon,
  HourglassEmpty,
  Check as ApprovedIcon,
} from '@material-ui/icons';

import {
  DesktopDatePicker,
  LocalizationProvider,
  TimelineOppositeContent,
} from '@mui/lab';

import AdapterDateFns from '@mui/lab/AdapterDateFns';

import { Reviews } from '@mui/icons-material';

import { green, red, yellow } from '@material-ui/core/colors';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormLabel,
  Link,
  ListItemIcon,
  Menu,
  MenuItem,
  colors,
} from '@material-ui/core';
import ReactSelect from 'react-select';
import {
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
} from '@material-ui/lab';
import { useStyles, StyledTableCell } from './styles';

import { useAxios } from '../../utils/hooks';
import { getChip } from '../../utils/getChip';
import { Request } from '../../models/request';
import { Record } from '../../models/record';
import Loader from '../../components/Loader';
import Select from '../../components/Select';
import { progressTypeIcons } from '../../utils/getProgressIcon';
import Snackbar, { AlertComponentProps } from '../../components/Snackbar';
import { SelectProps } from '../Records/List/dto';
import { User } from '../../models/user';
import { FormHistory } from '../../models/history';

const RequestTypes: { [key: string]: string } = {
  init_form: 'Ficha Inicial',
  adoption: 'Ficha de Contato Inicial MP',
  update: 'Atualização Cadastral',
  parent_init_form: 'Atendimento a Pais e/ou Responsáveis',
  discount: 'Pedido Redução de Valor',
  forwarding: 'Encaminhamento Terapeuta',
  closure: 'Encerramento do Atendimento',
};

const TypeToUrl = (
  type: string,
  resource_id: string,
  // record: string | null = null,
): string => {
  switch (type) {
    case 'init_form':
      return `/formularios/inicial/${resource_id}`;
    case 'parent_init_form':
      return `/formularios/inicial-responsaveis/${resource_id}`;
    case 'adoption':
      return `/formularios/inicial-adocao/${resource_id}`;
    case 'update':
      return `/formularios/atualizacao-cadastral/${resource_id}`;
    // case 'discount':
    //   return `/prontuarios/${record}/formularios/reducao-valor/${resource_id}`;
    // case 'forwarding':
    //   return `/prontuarios/${record}/formularios/encaminhamento-terapeuta/${resource_id}`;
    // case 'closure':
    //   return `/prontuarios/${record}/formularios/encerramento-atendimento/${resource_id}`;
    default:
      return '';
  }
};

const eventToTitle = (event: string): string => {
  switch (event) {
    case 'created':
      return 'Link único para ficha gerado pelo CEAPIA';
    case 'sent':
      return 'Ficha enviada para o CEAPIA';
    case 'reviewed':
      return 'Revisão de ficha solicitada pelo CEAPIA';
    case 'archived':
      return 'Ficha arquivada pelo CEAPIA';
    case 'approved':
      return 'Ficha aprovada pelo CEAPIA';
    default:
      return 'Ação não identificada';
  }
};

const eventToIcon = (event: string) => {
  switch (event) {
    case 'created':
      return <CreatedIcon />;
    case 'sent':
      return <SentIcon />;
    case 'reviewed':
      return <ReviewedIcon />;
    case 'archived':
      return <ArchivedIcon />;
    case 'approved':
      return <ApprovedIcon />;
    default:
      return <HourglassEmpty />;
  }
};

const eventToColor = (event: string) => {
  switch (event) {
    case 'created':
      return colors.blue[700];
    case 'sent':
      return colors.yellow[700];
    case 'reviewed':
      return colors.yellow[700];
    case 'archived':
      return colors.red[700];
    case 'approved':
      return colors.green[700];
    default:
      return <HourglassEmpty />;
  }
};

const screeningEmails = [
  'karla.fonseca@ceapia.com.br',
  'juliana.santos@ceapia.com.br',
  'daniela.lajus@ceapia.com.br',
  'mariana.santin@ceapia.com.br',
  'viviane.valmorbida@ceapia.com.br',
  'milene.merg@ceapia.com.br',
  'manoela.silva@ceapia.com.br',
  'fernanda.amorim@ceapia.com.br',
  'julia.foster@ceapia.com.br',
];

const Requests: React.FC = () => {
  const api = useAxios();
  const classes = useStyles();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [requests, setRequests] = useState<Request[]>([]);
  const [formHistory, setFormHistory] = useState<FormHistory[]>([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [idToApp, setIdToApp] = useState<string>('');
  const openMenu = Boolean(anchorEl);
  const [link, setLink] = useState('');
  const [linkOpen, setLinkOpen] = useState(false);
  const [openCloseRecord, setOpenCloseRecord] = useState(false);
  const [openUpdateRecord, setOpenUpdateRecord] = useState(false);
  const [historyOpen, setHistoryOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [recordId, setRecordId] = useState<string>('');
  const [recordNumber, setRecordNumber] = useState<number>(0);
  const [recordNumbers, setRecordNumbers] = useState<SelectProps[]>([]);
  const [rowsPerPage, setRowsPerPage] = useState(4);
  const formRef = useRef<FormHandles>(null);
  const [open, setOpen] = useState(false);
  const [proUsers, setProUsers] = useState<SelectProps[]>([]);
  const [coordUsers, setCoordUsers] = useState<SelectProps[]>([]);
  const [professionals, setProfessionals] = useState<SelectProps[]>([]);
  const [coordinators, setCoordinators] = useState<SelectProps[]>([]);
  const formFilterRef = useRef<FormHandles>(null);
  const [date, setDate] = useState<Date | null>(null);
  const [filters, setFilters] = useState('');
  const [filterTypes, setFilterTypes] = useState({
    type: '',
    status: '',
    date: '',
  });

  const [alert, setAlert] = useState<
    AlertComponentProps & { isActive: boolean }
  >({
    isActive: false,
    type: 'info',
    message: 'none',
  });

  useEffect(() => {
    async function getRequests() {
      try {
        const requestsResponse = await api.current?.get(`/requests?${filters}`);

        setRequests(requestsResponse?.data);
      } catch (error) {
        setAlert({
          isActive: true,
          type: 'error',
          message: 'Erro ao buscar aprovações.',
        });
      } finally {
        setLoading(false);
      }
    }

    getRequests();
  }, [api, filters]);

  const resetAlert = () => {
    setAlert({
      isActive: false,
      type: 'info',
      message: 'none',
    });
  };

  const handleReview = useCallback(
    async (id: string) => {
      try {
        setLoading(true);
        resetAlert();

        await api.current?.patch(`/requests/${id}/review`);

        const currentRequests = requests;
        const index = currentRequests.findIndex(
          ({ _id: currentRequestId }) => currentRequestId === id,
        );

        currentRequests[index].status = 'review';

        setRequests(currentRequests);
        setLoading(false);
        setAlert({
          isActive: true,
          type: 'success',
          message: 'Solicitação de revisão realizada com sucesso.',
        });
      } catch (error) {
        setLoading(false);
        setAlert({
          isActive: true,
          type: 'error',
          message: 'Erro ao solicitar revisão.',
        });
      }
    },
    [api, requests],
  );

  const handleArchive = useCallback(
    async (id: string) => {
      try {
        setLoading(true);
        resetAlert();

        await api.current?.patch(`/requests/${id}/archive`);

        const currentRequests = requests;
        const index = currentRequests.findIndex(
          ({ _id: currentRequestId }) => currentRequestId === id,
        );

        currentRequests[index].status = 'archived';

        setRequests(currentRequests);
        setLoading(false);
        setAlert({
          isActive: true,
          type: 'success',
          message: 'Avaliação arquivada com sucesso.',
        });
      } catch (error) {
        setLoading(false);
        setAlert({
          isActive: true,
          type: 'error',
          message: 'Erro ao arquivar avaliação.',
        });
      }
    },
    [api, requests],
  );

  const handleOpenApprove = useCallback(
    async (id: string) => {
      setLoading(true);
      resetAlert();

      try {
        const usersResponse = await api.current?.get('/users');

        if (usersResponse?.data) {
          setProUsers(
            usersResponse.data
              .filter(
                (user: User) =>
                  !user.attributes ||
                  (user.attributes && !user.attributes.coordenador),
              )
              // .filter((user: User) => screeningEmails.includes(user.email))
              .map((user: User) => ({
                value: user.id,
                label: `${user.firstName} ${user.lastName}`,
              })),
          );

          setCoordUsers(
            usersResponse.data
              .filter(
                (user: User) =>
                  user.attributes &&
                  user.attributes.coordenador &&
                  user.attributes.coordenador[0] === 'true',
              )
              .map((user: User) => ({
                value: user.id,
                label: `${user.firstName} ${user.lastName}`,
              })),
          );
        }

        setAlert({
          isActive: true,
          type: 'success',
          message: 'Dados de formuário carregados com sucesso.',
        });
      } catch (error) {
        setAlert({
          isActive: true,
          type: 'error',
          message: 'Erro ao carregar dados.',
        });
      } finally {
        setOpen(true);
        setIdToApp(id);
        setLoading(false);
      }
    },
    [api],
  );

  const handleDirectApprove = useCallback(
    async (requestId: string) => {
      try {
        setLoading(true);
        resetAlert();

        await api.current?.patch(`/requests/${requestId}/approve`);

        const currentRequests = requests;
        const index = currentRequests.findIndex(
          ({ _id: currentRequestId }) => currentRequestId === requestId,
        );

        currentRequests[index].status = 'approved';

        setRequests(currentRequests);

        setAlert({
          isActive: true,
          type: 'success',
          message: 'Aprovação realizada com sucesso.',
        });
      } catch (error) {
        setAlert({
          isActive: true,
          type: 'error',
          message: error.response.data.message,
        });
      } finally {
        setLoading(false);
      }
    },
    [api, requests],
  );

  const handleApprove = useCallback(async () => {
    try {
      setLoading(true);
      resetAlert();

      if (!coordinators.length && !professionals.length) {
        throw new Error('Preencha ao menos um coordenador.');
      }

      await api.current?.patch(`/requests/${idToApp}/approve`, {
        professional_id: [
          ...professionals.map((pro) => pro.value),
          ...coordinators.map((coord) => coord.value),
        ],
        professional: [
          ...professionals.map((pro) => pro.label),
          ...coordinators.map((coord) => coord.label),
        ],
      });

      const currentRequests = requests;
      const index = currentRequests.findIndex(
        ({ _id: currentRequestId }) => currentRequestId === idToApp,
      );

      currentRequests[index].status = 'approved';

      setRequests(currentRequests);
      setLoading(false);
      setAlert({
        isActive: true,
        type: 'success',
        message: 'Aprovação realizada com sucesso.',
      });

      setOpen(false);
      setIdToApp('');
    } catch (error) {
      resetAlert();
      setLoading(false);
      setAlert({
        isActive: true,
        type: 'error',
        message: error.response.data.message,
      });
    }
  }, [api, requests, coordinators, professionals, idToApp]);

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleLinkClose = () => {
    setLinkOpen(false);
    setLink('');
  };

  const handleCloseRecord = () => {
    setOpenCloseRecord(false);
    setRecordId('');
  };

  const handleHistoryClose = () => {
    setHistoryOpen(false);
  };

  const handleOpenHistory = useCallback(
    async (formId: string) => {
      resetAlert();
      setLoading(true);
      setAnchorEl(null);
      setLink('--');

      try {
        const historyResponse = await api.current?.get(
          `/forms/${formId}/history`,
        );

        if (historyResponse?.data) {
          setFormHistory(historyResponse?.data);
        } else {
          throw new Error();
        }

        setAlert({
          isActive: true,
          type: 'success',
          message: 'Histórico carregado com sucesso.',
        });
      } catch (error) {
        setAlert({
          isActive: true,
          type: 'error',
          message: 'Erro ao carregar histórico.',
        });
      } finally {
        setHistoryOpen(true);
        setLoading(false);
      }
    },
    [api],
  );

  const handleClickLinkOpen = useCallback(
    async (type: string, recordNumber?: number) => {
      resetAlert();
      setLoading(true);
      setAnchorEl(null);
      setOpenUpdateRecord(false);
      setLink('--');

      try {
        const linkResponse = await api.current?.post('/forms/token', {
          type,
          recordNumber,
        });
        let path;
        switch (type) {
          case 'init':
            path = 'formularios/inicial';
            break;
          case 'parentInit':
            path = 'formularios/inicial-responsaveis';
            break;
          case 'adoption':
            path = 'formularios/inicial-adocao';
            break;
          case 'update':
            path = 'formularios/atualizacao-cadastral';
            break;
          default:
        }

        if (linkResponse?.data && linkResponse?.data.form) {
          setLink(
            `${process.env.REACT_APP_CONTACT_URL}/${path}/${linkResponse.data.form}?token=${linkResponse.data.token}`,
          );
        } else {
          throw new Error();
        }

        setAlert({
          isActive: true,
          type: 'success',
          message: 'Link gerado com sucesso.',
        });
      } catch (error) {
        setAlert({
          isActive: true,
          type: 'error',
          message: 'Erro ao gerar link.',
        });
      } finally {
        setLinkOpen(true);
        setLoading(false);
      }
    },
    [api],
  );

  const handleFilters = useCallback(
    (type: string, data: any) => {
      setLoading(true);

      switch (type) {
        case 'type':
          setFilterTypes({
            ...filterTypes,
            type: data && data.value ? `&type=${data.value}` : '',
          });
          break;
        case 'status':
          setFilterTypes({
            ...filterTypes,
            status: data && data.value ? `&status=${data.value}` : '',
          });
          break;
        case 'date':
          setFilterTypes({
            ...filterTypes,
            date: data ? `&date=${moment(data).format('YYYY-MM-DD')}` : '',
          });
          break;
        default:
          break;
      }
    },
    [filterTypes],
  );

  const handleProfessionalSelect = (list: any) => {
    setProfessionals(list);
  };

  const handleCoordinatorSelect = (list: any) => {
    setCoordinators(list);
  };

  const handleIdSelect = (data: any) => {
    if (!data) {
      setRecordId('');
      return;
    }

    setRecordId(String(data.value));
  };

  const handleNumberSelect = (data: any) => {
    if (!data) {
      setRecordNumber(0);
      return;
    }

    setRecordNumber(Number(data.label));
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmitCloseRecord = useCallback(async () => {
    resetAlert();
    setLoading(true);

    try {
      await api.current?.patch(`/records/${recordId}`, {
        status: 'closed',
      });

      setAlert({
        isActive: true,
        type: 'success',
        message: 'Prontuário encerrado com sucesso.',
      });
    } catch (error) {
      setAlert({
        isActive: true,
        type: 'error',
        message: 'Erro ao encerrar prontuário.',
      });
    } finally {
      setOpenCloseRecord(false);
      setLoading(false);
    }
  }, [api, recordId]);

  const handleOpenCloseRecord = useCallback(async () => {
    resetAlert();
    setLoading(true);
    setAnchorEl(null);

    try {
      const recordResponse = await api.current?.get('/records');

      if (recordResponse?.data) {
        setRecordNumbers(
          recordResponse.data.map((record: Record) => ({
            value: record._id,
            label: record.number,
          })),
        );
      }

      setAlert({
        isActive: true,
        type: 'success',
        message: 'Prontuários carregados com sucesso.',
      });
    } catch (error) {
      setAlert({
        isActive: true,
        type: 'error',
        message: 'Erro ao carregar prontuário.',
      });
    } finally {
      setOpenCloseRecord(true);
      setLoading(false);
    }
  }, [api]);

  const handleOpenUpdateRecord = useCallback(async () => {
    resetAlert();
    setLoading(true);
    setAnchorEl(null);

    try {
      const recordResponse = await api.current?.get('/requests/recordNumbers');

      if (recordResponse?.data) {
        setRecordNumbers(
          recordResponse.data.map((record: Record) => ({
            value: record._id,
            label: record.number,
          })),
        );
      }

      setAlert({
        isActive: true,
        type: 'success',
        message: 'Prontuários carregados com sucesso.',
      });
    } catch (error) {
      setAlert({
        isActive: true,
        type: 'error',
        message: 'Erro ao carregar prontuário.',
      });
    } finally {
      setOpenUpdateRecord(true);
      setLoading(false);
    }
  }, [api]);

  const handleCloseUpdateRecord = () => {
    setOpenUpdateRecord(false);
    setRecordNumber(0);
  };

  useEffect(() => {
    setFilters(filterTypes.type + filterTypes.status + filterTypes.date);

    setPage(0);
  }, [filterTypes]);

  const handleMenu = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Loader loading={loading} />

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleMenuClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem
          /* prettier-ignore */
          onClick={() =>
               handleClickLinkOpen('init')}
        >
          <ListItemIcon>{progressTypeIcons.init}</ListItemIcon>
          <Typography variant="inherit">Ficha de Contato Inicial</Typography>
        </MenuItem>

        <Divider />

        <MenuItem
          /* prettier-ignore */
          onClick={() =>
               handleClickLinkOpen('parentInit')}
        >
          <ListItemIcon>{progressTypeIcons.parentInit}</ListItemIcon>
          <Typography variant="inherit">
            Atendimento a Pais e/ou Responsáveis
          </Typography>
        </MenuItem>

        <Divider />

        <MenuItem
          /* prettier-ignore */
          onClick={() =>
               handleClickLinkOpen('adoption')}
        >
          <ListItemIcon>{progressTypeIcons.adoption}</ListItemIcon>
          <Typography variant="inherit">Ficha de Contato Inicial MP</Typography>
        </MenuItem>

        <Divider />

        <MenuItem
          /* prettier-ignore */
          onClick={() =>
            handleOpenUpdateRecord()}
        >
          <ListItemIcon>{progressTypeIcons.update}</ListItemIcon>
          <Typography variant="inherit">
            Ficha de atualização cadastral
          </Typography>
        </MenuItem>

        <Divider />

        {/* <MenuItem
          onClick={() =>
            handleOpenCloseRecord()}
        >
          <ListItemIcon>{progressTypeIcons.inactivateRecord}</ListItemIcon>
          <Typography variant="inherit">Encerrar Prontuário</Typography>
        </MenuItem> */}
      </Menu>

      <Dialog
        open={linkOpen}
        onClose={handleLinkClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Link para ficha inical</DialogTitle>

        <DialogContent>
          <Link href={link} target="blank">
            {link}
          </Link>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleLinkClose}>Fechar</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={historyOpen}
        onClose={handleHistoryClose}
        fullWidth
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Histórico da Ficha</DialogTitle>

        <DialogContent>
          {formHistory.map((entry: FormHistory) => (
            <TimelineItem key="empty">
              <TimelineOppositeContent className={classes.opposite}>
                <Typography variant="body1" color="textSecondary">
                  {moment(entry.updatedAt).format('DD/MM/YYYY HH:mm')}
                </Typography>
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineDot
                  style={{ color: String(eventToColor(entry.event)) }}
                  color="inherit"
                >
                  {eventToIcon(entry.event)}
                </TimelineDot>
              </TimelineSeparator>
              <TimelineContent className={classes.content}>
                <Paper elevation={4} className={classes.paper}>
                  <Typography variant="subtitle1">
                    {eventToTitle(entry.event)}
                  </Typography>
                </Paper>
              </TimelineContent>
            </TimelineItem>
          ))}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleHistoryClose}>Fechar</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth
      >
        <Form ref={formRef} onSubmit={handleApprove}>
          <DialogTitle id="form-dialog-title">Encaminhamento</DialogTitle>
          {/*
          <Grid item xs={12}>
            <Divider />
          </Grid> */}

          <DialogContent style={{ minHeight: '40vh' }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} />

              <Grid item xs={12} />

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Selecione um ou mais terapeutas
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <ReactSelect
                  closeMenuOnSelect={false}
                  isMulti
                  options={proUsers}
                  onChange={handleProfessionalSelect}
                  menuPosition="fixed"
                />
              </Grid>

              <Grid item xs={12} />

              <Grid item xs={12}>
                <Divider />
              </Grid>

              <Grid item xs={12} />

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Selecione um ou mais coordenadores
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <ReactSelect
                  closeMenuOnSelect={false}
                  isMulti
                  options={coordUsers}
                  onChange={handleCoordinatorSelect}
                  menuPosition="fixed"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancelar</Button>
            <Button type="submit" color="primary" variant="contained">
              Salvar
            </Button>
          </DialogActions>
        </Form>
      </Dialog>

      <Dialog
        open={openCloseRecord}
        onClose={handleCloseRecord}
        aria-labelledby="form-dialog-title"
        fullWidth
      >
        <DialogTitle id="form-dialog-title">Encerrar Prontuário</DialogTitle>

        <DialogContent style={{ minHeight: '40vh' }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} />

            <Grid item xs={12} />

            <Grid item xs={12}>
              <FormLabel className={classes.formTitles}>
                Selecione o número do prontuário
              </FormLabel>
            </Grid>

            <Grid item xs={12}>
              <ReactSelect
                closeMenuOnSelect
                options={recordNumbers}
                onChange={(e) => handleIdSelect(e)}
                menuPosition="fixed"
                isClearable
              />
            </Grid>

            {recordId !== '' && (
              <>
                <Grid item xs={12} />
                <Grid item xs={12} />

                <Grid item xs={12}>
                  <FormLabel
                    className={classes.formTitles}
                    style={{
                      padding: '1%',
                      fontSize: '1.1rem',
                    }}
                  >
                    {`Tem certeza que deseja encerrar o prontuário de número ${
                      recordNumbers.find((record) => record.value === recordId)
                        ?.label
                    }?`}
                  </FormLabel>
                </Grid>
              </>
            )}
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseRecord}>Cancelar</Button>
          {recordId !== '' && (
            <Button
              variant="contained"
              onClick={() => handleSubmitCloseRecord()}
              style={{ background: red[700], color: '#fff' }}
            >
              Encerrar
            </Button>
          )}
        </DialogActions>
      </Dialog>

      <Dialog
        open={openUpdateRecord}
        onClose={handleCloseUpdateRecord}
        aria-labelledby="form-dialog-title"
        fullWidth
      >
        <DialogTitle id="form-dialog-title">
          Gerar Ficha de Atualização Cadastral
        </DialogTitle>

        <DialogContent style={{ minHeight: '40vh' }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} />

            <Grid item xs={12} />

            <Grid item xs={12}>
              <FormLabel className={classes.formTitles}>
                Selecione o número do prontuário
              </FormLabel>
            </Grid>

            <Grid item xs={12}>
              <ReactSelect
                closeMenuOnSelect
                options={recordNumbers}
                onChange={(e) => handleNumberSelect(e)}
                menuPosition="fixed"
                isClearable
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseUpdateRecord}>Cancelar</Button>

          {recordNumber > 0 && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleClickLinkOpen('update', recordNumber)}
            >
              Gerar Ficha
            </Button>
          )}
        </DialogActions>
      </Dialog>

      <Form ref={formFilterRef} initialData={{}} onSubmit={handleFilters}>
        <div className={classes.header}>
          <Button
            id="basic-button"
            aria-controls="basic-menu"
            aria-haspopup="true"
            variant="contained"
            color="primary"
            aria-expanded={open ? 'true' : undefined}
            startIcon={<LinkIcon />}
            className={classes.addButton}
            onClick={handleMenu}
          >
            Gerar link
          </Button>
        </div>

        <Paper elevation={0} className={classes.filterCard}>
          <Grid container spacing={2} alignItems="flex-end">
            <Grid item xs={12} sm={6} md={4} lg={2}>
              <span className={classes.filterLabel}>Tipo</span>
              <Select
                name="type"
                isMulti={false}
                placeholder="Tipo"
                isClearable
                className={classes.filterField}
                onChange={(e) => handleFilters('type', e)}
                options={[
                  { value: 'init_form', label: 'Ficha inicial' },
                  { value: 'parent_init_form', label: 'Atendimento a Pais' },
                  { value: 'adoption', label: 'Ficha de Contato Inicial MP' },
                  { value: 'update', label: 'Atualização cadastral' },
                  // { value: 'discount', label: 'Redução de valor' },
                  // { value: 'forwarding', label: 'Encaminhamento Terapeuta' },
                  // { value: 'closure', label: 'Encerramento Atendimento' },
                ]}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={2}>
              <span className={classes.filterLabel}>Status</span>
              <Select
                name="status"
                isMulti={false}
                placeholder="Status"
                isClearable
                className={classes.filterField}
                onChange={(e) => handleFilters('status', e)}
                options={[
                  { value: 'pending', label: 'Pendente' },
                  { value: 'approved', label: 'Aprovado' },
                  { value: 'review', label: 'Aguardando revisão' },
                  { value: 'archived', label: 'Arquivado' },
                ]}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={2}>
              <span className={classes.filterLabel}>Data</span>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                  inputFormat="dd/MM/yyyy"
                  value={date}
                  onChange={(d) => {
                    setDate(d);
                    handleFilters('date', d);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} size="small" fullWidth />
                  )}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
        </Paper>
      </Form>

      <TableContainer
        component={Paper}
        style={{ display: !loading ? '' : 'none', marginBottom: '2%' }}
      >
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <StyledTableCell>Tipo</StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell>Prontuário</StyledTableCell>
              <StyledTableCell>Paciente</StyledTableCell>
              <StyledTableCell align="center">Visualizar</StyledTableCell>
              <StyledTableCell>Atualizada em</StyledTableCell>
              <StyledTableCell>Histórico</StyledTableCell>
              <StyledTableCell>Link</StyledTableCell>
              <StyledTableCell>Ação</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!requests.length && (
              <TableRow>
                <TableCell component="th" scope="row" colSpan={7}>
                  <Typography>Nenhuma aprovação encontrada.</Typography>
                </TableCell>
              </TableRow>
            )}

            {(rowsPerPage > 0
              ? requests.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage,
                )
              : requests
            ).map((request) => (
              <TableRow key={request._id}>
                <TableCell component="th" scope="row">
                  {RequestTypes[request.type]}
                </TableCell>

                <TableCell>{getChip(request.status)}</TableCell>

                <TableCell>{request?.record?.number || '--'}</TableCell>

                <TableCell>
                  {request?.record?.patient?.name || '--'}

                  {request?.record?.patient2 &&
                    ` / ${request?.record?.patient2?.name}`}
                </TableCell>

                <TableCell align="center">
                  <Tooltip title="Visualizar">
                    <IconButton
                      onClick={() => {
                        history.push(
                          TypeToUrl(
                            request.type,
                            request.resource_id,
                            // request.record,
                          ),
                        );
                      }}
                      color="primary"
                    >
                      <Visibility />
                    </IconButton>
                  </Tooltip>
                </TableCell>

                <TableCell>
                  {moment(request.updatedAt).format('DD/MM/YYYY HH:mm')}
                </TableCell>

                <TableCell>
                  <Tooltip title="Histórico">
                    <IconButton
                      color="primary"
                      onClick={() => handleOpenHistory(request.resource_id)}
                    >
                      <History />
                    </IconButton>
                  </Tooltip>
                </TableCell>

                <TableCell>
                  {[
                    'init_form',
                    'parent_init_form',
                    'adoption',
                    'update',
                  ].includes(request.type) ? (
                    <Tooltip title="Abrir link">
                      <IconButton
                        href={`${process.env.REACT_APP_CONTACT_URL}${TypeToUrl(
                          request.type,
                          request.resource_id,
                        )}?token=${request.token}`}
                        target="blank"
                        color="primary"
                      >
                        <LinkIcon />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    '--'
                  )}
                </TableCell>

                <TableCell>
                  {request.status === 'pending' ? (
                    <Grid container spacing={1}>
                      <Grid item>
                        <Tooltip title="Aprovar">
                          <IconButton
                            aria-label="aprovar"
                            color="primary"
                            onClick={() => {
                              request.type === 'update'
                                ? handleDirectApprove(request._id)
                                : handleOpenApprove(request._id);
                            }}
                          >
                            <Check
                              fontSize="large"
                              style={{ color: green[700] }}
                            />
                          </IconButton>
                        </Tooltip>
                      </Grid>

                      <Grid item>
                        <Tooltip title="Solicitar Revisão">
                          <IconButton
                            aria-label="revisar"
                            color="primary"
                            onClick={() => handleReview(request._id)}
                          >
                            <Reviews
                              fontSize="large"
                              style={{ color: yellow[800] }}
                            />
                          </IconButton>
                        </Tooltip>
                      </Grid>

                      <Grid item>
                        <Tooltip title="Arquivar">
                          <IconButton
                            aria-label="arquivar"
                            color="primary"
                            onClick={() => handleArchive(request._id)}
                          >
                            <Archive
                              fontSize="large"
                              style={{ color: red[700] }}
                            />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  ) : (
                    <span>Nenhuma ação necessária.</span>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 100]}
          component="div"
          count={requests.length}
          rowsPerPage={rowsPerPage}
          labelRowsPerPage={<span>Solicitações por página:</span>}
          labelDisplayedRows={({ count, from, to }) => {
            return `${from} - ${to} de ${count}`;
          }}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>

      {alert.isActive && <Snackbar {...alert} />}
    </>
  );
};

export default Requests;
